module.exports = __webpack_public_path__ + "static/img/beijin.c2f122e1.png";